import Vue from "vue"
import Router from 'vue-router';

const Home = () => import(/* webpackChunkName: "home" */ '../views/home/index')
const Exam = () => import(/* webpackChunkName: "exam" */ '../views/exam/index')
const Detail = () => import(/* webpackChunkName: "detail" */ '../views/detail/index')
const Success = () => import(/* webpackChunkName: "success" */ '../views/success/index')

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: { title: '领课首页' }
    },
    {
      path: '/exam',
      name: 'exam',
      component: Exam,
      meta: { title: '领取考试页' }
    },
    {
      path: '/detail',
      name: 'detail',
      component: Detail,
      meta: { title: '课程详情页' }
    },
    {
      path: '/success',
      name: 'success',
      component: Success,
      meta: { title: '课程详情页' }
    }
  ]
})

Vue.use(Router)
export default router